module.exports = __webpack_public_path__ + "static/media/34-2.42e8c848.mp3";